module.exports = new __parcel__URL__("select-github-csv.b252e0df.svg").toString();